import React from 'react';

export const ErrorMessage: React.FC = ({ children }) => {
    return <span style={{ color: 'red' }}>{children}</span>;
};
